import Vue from 'vue'
import Router from 'vue-router'
import Catalog from './views/Catalog.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    // base: '/products/',
    routes: [

        {
            path: '/products/',
            name: 'home',
            component: Catalog,
            props: true,
            pathToRegexpOptions: { strict: true },
        },

        {
            path: '/products/:categorySlug/',
            name: 'category',
            component: Catalog,
            props: true,
            pathToRegexpOptions: { strict: true },
        },

        {
            path: '/products/:categorySlug/:subcategorySlug/',
            name: 'subcategory',
            component: Catalog,
            props: true,
            pathToRegexpOptions: { strict: true },
        },

        {
            path: '/brands/:brandSlug/',
            name: 'brand',
            component: Catalog,
            props: true,
            pathToRegexpOptions: { strict: true },
        },
    ],

    // scrollBehavior (to, from, savedPosition) {
    //     return { x: 0, y: 0 }
    // }

})
